/*
  ============================================================
  FILE: ctx-stray-text-guard.js
  LOCATION: assets/ctx-stray-text-guard.js
  LOADED: layout/theme.liquid, site-wide

  Removes bare text nodes that are direct children of <body>.

  WHY THIS EXISTS — and why it is a safety net, not a fix

  A Google Tag Manager Custom HTML tag (container GTM-TD4PX9X7) contains
  JavaScript that is not wrapped in <script> tags:

      oaiq("measure", "contents_viewed", { type: "contents" });

  GTM injects the tag's contents into the page, so without the wrapper that
  line lands in <body> as PLAIN TEXT. It rendered as visible code just under
  the footer and added ~27-55px of dead space below it on every page — the
  width varies because the text wraps differently per viewport.

  Two things follow from that, and only one of them is fixed here:

    1. The visible junk and the gap. This file removes it.
    2. The tracking. That measure() call never executes, so whatever
       "contents_viewed" was meant to record has never been recorded. THIS FILE
       DOES NOT FIX THAT. It has to be fixed in GTM by wrapping the tag body in
       <script>...</script>.

  So do not treat the clean-looking footer as evidence the tag works.

  A non-whitespace text node directly inside <body> is never legitimate content
  in this theme — every real thing lives inside a section, a snippet or an app
  block — which is what makes it safe to remove on sight. Whitespace nodes are
  left alone; they are how the HTML formatter separates elements.

  Observed rather than swept once: GTM fires after load, and can fire again on
  route changes and consent updates.
  ============================================================
*/

(function () {
  'use strict';

  function strip() {
    var removed = 0;
    /* Snapshot first — removing while iterating live childNodes skips entries. */
    var nodes = Array.prototype.slice.call(document.body.childNodes);
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.nodeType !== 3) continue;              // text nodes only
      if (!n.textContent || !n.textContent.trim()) continue;  // keep whitespace
      n.parentNode.removeChild(n);
      removed++;
    }
    return removed;
  }

  strip();

  if (window.MutationObserver) {
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 3 && added[j].textContent && added[j].textContent.trim()) {
            strip();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true });
  } else {
    /* No observer: catch the common case of a tag firing shortly after load. */
    window.addEventListener('load', function () { setTimeout(strip, 1200); });
  }
})();
